import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import Seo from "../components/Seo";
import NewsArticleLayout from "../components/NewsArticleLayout";
import { newsArticles } from "../data/newsArticles";

const NewsArticle = () => {
  const { slug } = useParams();
  const article = newsArticles.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) return <Navigate to="/news" replace />;

  const related = newsArticles
    .filter((a) => a.slug !== article.slug && a.pillarPrimary === article.pillarPrimary)
    .slice(0, 3);

  const description =
    (article.subtitle || article.excerpt || `Articolo OnSports sulla sponsorship sportiva italiana: ${article.title}.`)
      .slice(0, 160);
  const heroImage = article.heroImage || article.image;

  return (
    <>
      <Seo
        title={`${article.title} | OnSports News`}
        description={description}
        path={`/news/${article.slug}`}
        image={heroImage}
      />
      <NewsArticleLayout article={article} related={related} />
    </>
  );
};

export default NewsArticle;
